import { makeStyles } from "tss-react/mui";

export const useOnBoardingDashboardStyles = makeStyles()((theme) => ({
  root:{
    display:"flex",
    flexDirection:"column",
    alignSelf: "start",
    justifyContent:"start",
    width: "88.88%",
    height: "71.11%",
    marginTop: theme.spacing(5),
    gap: theme.spacing(8),
    "@media(min-width: 1536px)": {
      width: "88.80%",
      height: "72.68%",
      gap: theme.spacing(9),
      marginTop: theme.spacing(5),
    },
    "@media(min-width: 1920px)": {
      width: "88.95%",
      height: "72.31%",
      gap:theme.spacing(7),
      marginTop:  theme.spacing(7),
    },
  }
}));
